import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { fetchResourceActions } from '~src/resourceActions/actions/ResourceActions';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { getFilterClausesForTypes } from '~src/spacesPlatform/actions/filters/getFilterClausesForTypes';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectCurrentlyApplicableContentTypes, selectMixedContentFilterClauses } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { isSiteUsersIntegrationSubspace, NullProjectIdForNonProjects } from '~src/spacesPlatform/state/SpaceInfo';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllSiteUsersSpace, AllSiteUsersSpaceDispatchProps, AllSiteUsersSpaceOwnProps, AllSiteUsersSpaceStateProps } from './AllSiteUsersSpace';

// Memoized so unrelated store updates keep the same array reference.
const selectCombinedCountFilters = createSelector(
  selectMixedContentFilterClauses,
  selectCurrentlyApplicableContentTypes,
  selectSpaceInfo,
  (mixedFilters, applicableContentTypes, spaceInfo) => getFilterClausesForTypes(
    mixedFilters,
    ['siteuser'],
    applicableContentTypes,
    NullProjectIdForNonProjects,
    spaceInfo
  )
);

const mapStateToProps: MapStateToProps<AllSiteUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
  canAddUsers: getSessionManagementServiceInstance().canSessionManageUsersOrActOnResource('User', ['CREATE_USER_WITH_ROLE']),
  isOnIntegrationUsersSubspace: isSiteUsersIntegrationSubspace(state.spaceInfo),
  combinedCountFilters: selectCombinedCountFilters(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
  fetchResourceActions,
  enterSpace,
}, dispatch);

export const ConnectedAllSiteUsersSpace: React.ComponentClass<AllSiteUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersSpace);
